export const environment = {
  production: true,
  envName: "prod",
  apiRootUrl: "/api/",
  dateLocale: "fr-CH",
  googleAnalyticsID: "G-Y27EN3FXBS"
};
